import classNames from 'classnames';

import { setupForDark } from '@theme';

function Switch({
  value = false,
  onChange = () => {},
  disabled = false
}: {
  value: boolean;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <div
      data-testid='switch'
      onClick={() => {
        if (disabled) return;
        onChange(!value);
      }}
      className={classNames(
        'flex items-center rounded-full',
        'w-[51px] h-[31px] p-[2px]',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        value ? 'justify-end' : 'justify-start',
        value ? setupForDark('bg-violet-700') : setupForDark('bg-icon-secondary')
      )}
    >
      <div
        className={classNames(
          'w-[27px] h-[27px] rounded-full shadow-md',
          setupForDark('bg-text-white')
        )}
      ></div>
    </div>
  );
}

export default Switch;
